import { useState, useEffect } from 'react';

import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import type { PublicPluginAPI } from '@atlaskit/editor-common/types';

import type { AIPlugin } from '@atlassian/editor-plugin-ai';

import type { PromptActionCompleted, ActionType, ActionSource } from './ImproveWritingFlag';

interface AIExperienceState {
	aiPromptActionCompleted?: {
		actionSource?: ActionSource;
		actionType?: ActionType;
		prompt?: string;
	};
}

export const useEditorAIActionFlag = (api: PublicPluginAPI<[AIPlugin]>) => {
	const [promptActionCompleted, setPromptActionCompleted] = useState<PromptActionCompleted | null>(
		null,
	);

	// Listen to the AI prompt action plugin state
	// `aiPromptActionCompleted` is part of AIPlugin EditorPluginAISharedState
	const { actionSource, actionType, prompt } = useSharedPluginStateWithSelector(
		api,
		['aiExperience'],
		({ aiExperienceState }: { aiExperienceState?: AIExperienceState }) => {
			return {
				actionSource: aiExperienceState?.aiPromptActionCompleted?.actionSource,
				actionType: aiExperienceState?.aiPromptActionCompleted?.actionType,
				prompt: aiExperienceState?.aiPromptActionCompleted?.prompt,
			};
		},
	);

	// Update state when plugin state changes to display flag
	useEffect(() => {
		if (actionType && prompt === 'improve-writing') {
			setPromptActionCompleted({
				actionSource: actionSource as ActionSource,
				actionType: actionType as ActionType,
				prompt,
			});
		}
	}, [actionSource, actionType, prompt]);

	return {
		promptActionCompleted,
	};
};
